const DEBUG = false;

export {DEBUG};